import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "./-utils/require-admin";

export const Route = createFileRoute("/_app/sistema")({
	beforeLoad: requireAdmin,
	component: Outlet,
});
